import { SubscriptionCFA } from '@/account/types/subscription';

interface GetSwapEligibilityResponse {
  /** Whether the user is allowed to perform a normal swap */
  canSwap: boolean;
  /** Whether the user can see any type of swap (i.e. does the user have a vehicle on an active subscription?) */
  canViewSwap: boolean;
  /** Whether the user is allowed to perform a legacy swap
   *
   *  NOTE: We have no more active legacy customers so this should always be false now and should not be relied upon.
   */
  canLegacySwap: boolean;
}

/**
 * Util to determine a user's swap eligibility.
 * TODO: Pending discussion, some of this information will likely be moved to the backend.
 * @param subscription Subscription for customer
 */
export const getSwapEligibility = (
  subscription: SubscriptionCFA | undefined | null
): GetSwapEligibilityResponse => {
  if (!subscription) {
    return {
      canSwap: false,
      canViewSwap: false,
      canLegacySwap: false,
    };
  }

  return {
    canViewSwap: subscription.has_vehicle,
    canSwap: subscription.can_swap,
    canLegacySwap: subscription.can_legacy_swap,
  };
};
